module.exports = __webpack_public_path__ + "img/cloudview_seatbelt.23a5a255.jpg";